import React from 'react'
import "./FeeHero.css"

function FeeHero() {
  return (
    <div className="feepage-hero" style={{ backgroundImage: "url('/images/sihsbuilding.jpg')" }}>
      <div className="feeoverlay">
        <h1>Fee Structure</h1>
      </div>
    </div>
  )
}

export default FeeHero
